// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.active[data-v-5d437dd8] {\n  background: #fff;\n  color: #37474F !important;\n}\n", ""]);
// Exports
module.exports = exports;
